import { render, staticRenderFns } from "./o-article-v2.vue?vue&type=template&id=b60001fa&scoped=true"
import script from "./o-article-v2.vue?vue&type=script&lang=js"
export * from "./o-article-v2.vue?vue&type=script&lang=js"
import style0 from "./o-article-v2.vue?vue&type=style&index=0&id=b60001fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60001fa",
  null
  
)

export default component.exports